import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppColors } from "../../../../util/AppColors";

// Import Thunks
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../../components/CustomSwitch";
import {
  createKennel,
  deleteKennel,
  getKennelList,
  updateKennel,
} from "../../../../redux/reducers/kennelSlice";
function Kennel() {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ Kennel: "" });
  const [editForm, setEditForm] = useState({ Kennel: "" });
  // Add states
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const kennelState = useSelector((state) => state.kennel);
  const kennelList = kennelState.list;

  useEffect(() => {
    dispatch(getKennelList());
  }, [dispatch]);

  const handleAddOrUpdate = () => {
    if (!form.Kennel.trim()) return;

    if (editIndex !== null) {
      const kennel = kennelList[editIndex];
      dispatch(
        updateKennel({ facilityId: kennel.facilityId, name: form.Kennel })
      );
    } else {
      dispatch(createKennel({ name: form.Kennel }));
    }

    handleCloseDrawer();
  };
  const handleDeleteClick = (index) => {
    setDeleteIndex(index);
    setDelModVisible(true);
  };

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleDelConfirm = () => {
    const kennel = kennelList[deleteIndex];
    dispatch(deleteKennel({ facilityId: kennel.facilityId }));
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleEdit = (index) => {
    const kennel = kennelList[index];
    setForm({ Kennel: kennel.name });
    setEditIndex(index);
    setOpenDrawer(true);
  };
  const handleUpdate = () => {
    if (!editForm.Kennel.trim()) return;

    const kennel = kennelList[editIndex];
    dispatch(
      updateKennel({ facilityId: kennel.facilityId, name: editForm.Kennel })
    )
      .unwrap()
      .then(() => {
        handleCloseEditDialog(); // Close dialog after update
      })
      .catch((error) => {
        console.error("Failed to update Kennel:", error);
      });
  };

  const handleDelete = (index) => {
    const kennel = kennelList[index];
    dispatch(deleteKennel({ facilityId: kennel.facilityId }));
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setForm({ Kennel: "" });
    setEditIndex(null);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
    setEditForm({ Kennel: "" });
    setEditIndex(null);
  };

  const filteredRows = kennelList.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangeSwitch = (status, kennel) => {
    dispatch(
      updateKennel({
        facilityId: kennel?.facilityId,
        name: kennel?.name,
        status,
      })
    ).then((res) => {
      if (res?.payload) dispatch(getKennelList());
    });
  };

  return (
    <Box p={3}>
      {/* Top section */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        flexWrap="wrap"
      >
        <Box display="flex" gap={2} mx="auto" mb={2}>
          <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          />
          <Button variant="contained" onClick={() => setOpenDrawer(true)}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Kennels: {filteredRows.length}
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Kennel</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No records found
                </TableCell>
              </TableRow>
            ) : (
              filteredRows.map((kennel, index) => (
                <TableRow key={kennel.facilityId}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{kennel.name}</TableCell>
                  <TableCell>
                    <div>
                      <div>
                        <CustomSwitch
                          value={kennel?.status}
                          onChange={(e) =>
                            handleChangeSwitch(e?.target?.value, kennel)
                          }
                          greenToRed
                        />
                      </div>
                      <div>
                        {kennel?.status ? "Active" : "Under Maintenance"}
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>{kennel.userName || "-"}</TableCell>
                  <TableCell>
                    {new Date(kennel.createdDate).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => handleEdit(index)}
                    >
                      <EditIcon />
                    </IconButton>
                    {/* <IconButton color="error" size="small" onClick={() => handleDelete(index)}>
                      <DeleteIcon />
                    </IconButton> */}
                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => handleDeleteClick(index)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Drawer */}
      <Drawer anchor="right" open={openDrawer} onClose={handleCloseDrawer}>
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Kennel" : "Create Kennel"}
            </Typography>
            <IconButton onClick={handleCloseDrawer} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Kennel Name"
            value={form.Kennel}
            onChange={(e) => setForm({ ...form, Kennel: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={handleAddOrUpdate}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Edit Dialog */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Kennel;
